// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.notification{
  display:flex;
  flex-flow:wrap;
  gap:0.5rem;
  align-items:center;
  justify-content:left;
  min-height:2rem;
  padding:0.5rem;
  margin:1rem 0;
  overflow-wrap:break-word;
  background-color:transparent;
  background-clip:padding-box;
  border-radius:0.25rem;
  font-size:0.875rem;
  line-height:1.375rem;
}
.notification__message{
    flex:1;
    width:100%;
  }
.notification__message > p{
      margin:0;
    }
.notification__message > div > p{
      margin:0;
    }
.notification__icon{
    align-self:flex-start;
  }
.notification--error{
    background-color:#fdeae9;
  }
.notification--error .notification__icon{
      color:#dd201d;
    }
.notification--info{
    background-color:#e5f5ff;
  }
.notification--info .notification__icon{
      color:#206dd2;
    }
.notification--success{
    background-color:#e7f3e2;
  }
.notification--success .notification__icon{
      color:#428629;
    }
.notification--warn{
    background-color:#ffede0;
  }
.notification--warn .notification__icon{
      color:#db6b16;
    }
.notification--compact{
    margin:0;
  }
.notification--toast{
    padding:0.25rem 0.5rem;
    margin:0;
    box-shadow:0 0.25rem 0.25rem rgb(0, 0, 0, 0.1);
  }
`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
